import { useTheme } from "@emotion/react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

function PeriodSummary({ data }) {
	const { t } = useTranslation();
	const theme = useTheme();

	const userCurrency = localStorage.getItem("userCurrency");

	const currentPeriodData = data[data.length - 1];
	const income = (currentPeriodData ? currentPeriodData.income : 0)
		.toFixed(2)
		.toLocaleString();
	const expense = (currentPeriodData ? currentPeriodData.expense : 0)
		.toFixed(2)
		.toLocaleString();
	const savings = (income - expense).toFixed(2).toLocaleString();
	const savingsRate = income > 0 ? (savings / income) * 100 : 0;

	const displayData = [
		{
			label: t("income"),
			value: income,
			suffix: userCurrency,
			color: theme.palette.values.positive,
		},
		{
			label: t("expense"),
			value: expense,
			suffix: userCurrency,
			color: theme.palette.values.negative,
		},
		{
			label: t("savings"),
			value: savings,
			suffix: userCurrency,
			color: theme.palette.text.primary,
		},
		{
			label: t("savingsRate"),
			value: savingsRate.toFixed(2),
			suffix: "%",
			color: theme.palette.text.primary,
		},
	];

	const topRowBoxStyles = {
		display: "flex",
		justifyContent: "space-between",
		flexWrap: "wrap",
		gap: 2,
		m: 2,
	};
	const periodBoxStyles = {
		display: "flex",
		flexGrow: 1,

		flexDirection: "column",
		bgcolor: theme.palette.background.paper,
		borderRadius: "10px",
		alignItems: "center",
		justifyContent: "space-between",
		py: 1,
		px: 2,
	};

	return (
		<>
			<Box sx={topRowBoxStyles}>
				{displayData.map((item) => (
					<Box sx={periodBoxStyles} key={item.label}>
						<Typography
							variant="h6"
							id="tableTitle"
							component="div"
							sx={{
								marginBottom: 0,
								color: item.color,
								fontWeight: "bold",
							}}
						>
							{item.value} {item.suffix}
						</Typography>
						<Typography
							variant="body2"
							id="tableTitle"
							component="div"
							sx={{
								marginBottom: 0,
								color: theme.palette.text.secondary,
							}}
						>
							{item.label}
						</Typography>
					</Box>
				))}
			</Box>
		</>
	);
}

export default PeriodSummary;
